<template>
  <transition name="fade">
    <div
      v-if="visible"
      :class="['rupee-loader-overlay', { 'is-fixed': isFullScreen }]"
      :style="overlayStyle"
    >
      <div class="rupee-loader-content">
        <div ref="lottieContainer" class="lottie-coin-box"></div>
        <div v-if="text" class="rupee-loader-text">{{ text }}</div>
      </div>
    </div>
  </transition>
</template>

<script>
import lottie from "lottie-web";
import rupeeAnimationData from "@/assets/RupeeCoin.json";

export default {
  name: "RupeeLoader",
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    isFullScreen: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: "rgba(255, 255, 255, 0.92)",
    },
    color: {
      type: String,
      default: "#9a6b27",
    },
    spinner: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    size: {
      type: [Number, String],
      default: 130,
    },
    minDuration: {
      type: Number,
      default: 700,
    },
    speed: {
      type: Number,
      default: 0.8,
    },
  },
  data() {
    return {
      anim: null,
      visible: false,
      startTime: 0,
      hideTimer: null,
    };
  },
  computed: {
    overlayStyle() {
      let bg = this.backgroundColor || "rgba(255, 255, 255, 0.9)";
      if (
        bg.toLowerCase() === "#ffffff" ||
        bg.toLowerCase() === "#fff" ||
        bg.toLowerCase() === "white"
      ) {
        bg = "rgba(255, 255, 255, 0.88)";
      }
      return {
        backgroundColor: bg,
      };
    },
  },
  watch: {
    active: {
      immediate: true,
      handler(val) {
        if (val) {
          if (this.hideTimer) {
            clearTimeout(this.hideTimer);
            this.hideTimer = null;
          }
          this.startTime = Date.now();
          this.visible = true;
          this.$nextTick(() => {
            this.playAnimation();
          });
        } else {
          if (!this.visible) return;
          const elapsed = Date.now() - this.startTime;
          const remaining = Math.max(0, this.minDuration - elapsed);
          this.hideTimer = setTimeout(() => {
            this.visible = false;
            this.destroyAnimation();
          }, remaining);
        }
      },
    },
  },
  mounted() {
    if (this.active) {
      this.visible = true;
      this.startTime = Date.now();
      this.$nextTick(() => {
        this.playAnimation();
      });
    }
  },
  beforeDestroy() {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
    }
    this.destroyAnimation();
  },
  methods: {
    playAnimation() {
      this.destroyAnimation();
      if (!this.$refs.lottieContainer) return;
      try {
        this.anim = lottie.loadAnimation({
          container: this.$refs.lottieContainer,
          renderer: "svg",
          loop: true,
          autoplay: true,
          animationData: rupeeAnimationData,
        });
        if (this.anim && this.speed) {
          this.anim.setSpeed(this.speed);
        }
      } catch (err) {
        console.error("Failed to load Rupee Coin animation:", err);
      }
    },
    destroyAnimation() {
      if (this.anim) {
        this.anim.destroy();
        this.anim = null;
      }
    },
  },
};
</script>

<style scoped>
.rupee-loader-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.rupee-loader-overlay.is-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999999;
}

.rupee-loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
}

.lottie-coin-box {
  width: 150px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rupee-loader-text {
  margin-top: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #9a6b27;
  letter-spacing: 0.4px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
